<app-top-bar [isBack]="!order && !isOderId" [title]="'Допомога з поїздкою'"></app-top-bar>
<div class="trip-container">
  <div class="info-trip-text hint-color">
    Перегляньте категорії звернень
  </div>
  <app-trip-card [userType]="userType" [passengerReq]="passengerReq" [driverReq]="driverReq"></app-trip-card>
  <div class="departments-block">
    @for (item of departments$ | async; track $index) {
      <div class="department-item block-background" (click)="navigateToDepartment(item.uuid, item.display_name)">
        <div class="department-item-text main-text-color">{{ item.display_name }}</div>
        <mat-icon class="accent-color">chevron_right</mat-icon>
      </div>
    }
  </div>
</div>
